"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInput = exports.InputQuill = exports.InputPassword = exports.Input = exports.animatedComponents = void 0;
exports.FormError = FormError;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importStar(require("react"));
const react_quill_1 = __importDefault(require("react-quill"));
const ErrorMessage_1 = __importDefault(require("./ErrorMessage"));
const fa_1 = require("react-icons/fa");
const animated_1 = __importDefault(require("react-select/animated"));
exports.animatedComponents = (0, animated_1.default)();
function FormError({ error }) {
    const message = typeof error === "string" ? error : error ? error.message : error;
    if (!message)
        return null;
    return react_1.default.createElement(ErrorMessage_1.default, { message: message });
}
exports.Input = react_1.default.forwardRef((props, ref) => {
    const { name, error, id, label, required, readOnly, customClassInput, customClassLabel, customClassContainer } = props, rest = __rest(props, ["name", "error", "id", "label", "required", "readOnly", "customClassInput", "customClassLabel", "customClassContainer"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: customClassContainer ? customClassContainer : "mb-2" },
            label && (react_1.default.createElement("label", { htmlFor: id, className: `form-label form-label-formule ${customClassLabel}`, "aria-labelledby": id },
                label,
                required && (react_1.default.createElement("span", { className: "text-danger", style: { fontSize: 15 } }, "*")))),
            react_1.default.createElement("input", Object.assign({ className: `form-control form-control-input-formule ${customClassInput}`, name: name, id: id, ref: ref, readOnly: readOnly || false }, rest, { onWheel: (event) => event.currentTarget.blur() })),
            react_1.default.createElement(FormError, { error: error }))));
});
exports.InputPassword = react_1.default.forwardRef((props, ref) => {
    const { name, error, id, label, required, readOnly } = props, rest = __rest(props, ["name", "error", "id", "label", "required", "readOnly"]);
    const [showPassword, setShowPassword] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("label", { htmlFor: id, className: "form-label custom-form-label", "aria-labelledby": id },
            label,
            required && (react_1.default.createElement("span", { className: "text-danger", style: { fontSize: 24 } }, "*"))),
        react_1.default.createElement("div", { className: "input-group custom-input-group position-relative mb-1" },
            react_1.default.createElement("input", Object.assign({ className: "form-control custom-form-control", name: name, id: id, ref: ref, readOnly: readOnly || false, type: showPassword ? "text" : "password" }, rest)),
            react_1.default.createElement("span", { className: "input-group-icon icon__wrapper", id: "basic-addon2", onClick: () => setShowPassword((showPassword) => !showPassword) }, showPassword ? (react_1.default.createElement(fa_1.FaEye, { className: "show_password__icon" })) : (react_1.default.createElement(fa_1.FaEyeSlash, { className: "hide_password__icon" })))),
        react_1.default.createElement(FormError, { error: error })));
});
exports.InputQuill = react_1.default.forwardRef((props, ref) => {
    const { name, error, id, label, required, readOnly, customClassInput, customClassLabel, value, onChange } = props, rest = __rest(props, ["name", "error", "id", "label", "required", "readOnly", "customClassInput", "customClassLabel", "value", "onChange"]);
    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [
                { list: "ordered" },
                { list: "bullet" },
                { indent: "-1" },
                { indent: "+1" },
            ],
            ["link", "image"],
            [
                {
                    color: [
                        "#4be1b4",
                        "#f45b5b",
                        "#000000",
                        "#e60000",
                        "#ff9900",
                        "#ffff00",
                        "#008a00",
                        "#0066cc",
                        "#9933ff",
                        "#ffffff",
                        "#ffcccc",
                        "#ffe699",
                        "#ffffcc",
                        "#cfe2f3",
                        "#d9d2e9",
                        "#fff1f1",
                        "#21a3740d",
                        "#f45b5b0d",
                        // Couleurs standard WYSIWYG
                        "#808080",
                        "#C0C0C0",
                        "#800000",
                        "#FF0000",
                        "#808000",
                        "#008000",
                        "#00FF00",
                        "#008080",
                        "#00FFFF",
                        "#000080",
                        "#0000FF",
                        "#800080",
                        "#FF00FF",
                        "#8B0000",
                        "#006400",
                        "#00008B",
                        "#FF8C00",
                        "#ADD8E6",
                        "#90EE90",
                        "#FFC0CB",
                        "#87CEEB",
                        "#FFD700",
                        "#A52A2A",
                        "#FF7F50",
                        "#40E0D0",
                        "#708090",
                        "#E6E6FA",
                        "#4B0082",
                        "#F5F5DC",
                        "#FA8072",
                        "#F0E68C",
                        "#FFB6C1",
                        "#DC143C",
                        "#2E8B57",
                        "#4169E1",
                    ],
                },
                {
                    background: [
                        "#4be1b4",
                        "#f45b5b",
                        "#000000",
                        "#e60000",
                        "#ff9900",
                        "#ffff00",
                        "#008a00",
                        "#0066cc",
                        "#9933ff",
                        "#ffffff",
                        "#ffcccc",
                        "#ffe699",
                        "#ffffcc",
                        "#cfe2f3",
                        "#d9d2e9",
                        "#fff1f1",
                        "#21a3740d",
                        "#f45b5b0d",
                        // Couleurs standard WYSIWYG
                        "#808080",
                        "#C0C0C0",
                        "#800000",
                        "#FF0000",
                        "#808000",
                        "#008000",
                        "#00FF00",
                        "#008080",
                        "#00FFFF",
                        "#000080",
                        "#0000FF",
                        "#800080",
                        "#FF00FF",
                        "#8B0000",
                        "#006400",
                        "#00008B",
                        "#FF8C00",
                        "#ADD8E6",
                        "#90EE90",
                        "#FFC0CB",
                        "#87CEEB",
                        "#FFD700",
                        "#A52A2A",
                        "#FF7F50",
                        "#40E0D0",
                        "#708090",
                        "#E6E6FA",
                        "#4B0082",
                        "#F5F5DC",
                        "#FA8072",
                        "#F0E68C",
                        "#FFB6C1",
                        "#DC143C",
                        "#2E8B57",
                        "#4169E1",
                    ],
                },
            ],
        ],
    };
    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
        "color",
        "background",
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "mb-3" },
            label && (react_1.default.createElement("label", { htmlFor: id, className: `form-label custom-form-label ${customClassLabel}`, "aria-labelledby": id },
                label,
                required && (react_1.default.createElement("span", { className: "text-danger", style: { fontSize: 15 } }, "*")))),
            react_1.default.createElement(react_quill_1.default, Object.assign({ className: `${customClassInput}`, 
                // name={name}
                id: id, 
                // ref={ref}
                readOnly: readOnly || false }, rest, { theme: "snow", value: value, onChange: (val) => onChange(val), modules: modules, formats: formats })),
            react_1.default.createElement(FormError, { error: error }))));
});
exports.SelectInput = react_1.default.forwardRef((props, ref) => {
    const { name, error, label, options, hiddenFirstOption, required, customClassLabel, customClassInput, placeholder } = props, rest = __rest(props, ["name", "error", "label", "options", "hiddenFirstOption", "required", "customClassLabel", "customClassInput", "placeholder"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        label && react_1.default.createElement("label", { htmlFor: name, className: `form-label form-label-formule ${customClassLabel}`, "aria-labelledby": name },
            label,
            "\u00A0",
            required && (react_1.default.createElement("span", { className: "text-danger", style: { fontSize: 15 } }, "*"))),
        react_1.default.createElement("select", Object.assign({ name: name, id: name, ref: ref, className: `form-control form-control-input-formule mb-2 ${customClassInput}` }, rest),
            hiddenFirstOption && (react_1.default.createElement("option", { value: "", disabled: true, selected: true }, placeholder || "Sélectionner une option")), options === null || options === void 0 ? void 0 :
            options.map((option) => (react_1.default.createElement("option", { value: option.value, key: option.value }, option.label)))),
        react_1.default.createElement(FormError, { error: error })));
});
